import cx from "classnames";

import TableCellContent, { type TableCellContentProps } from "ds/components/Table/Row/CellContent";

import styles from "./styles.module.css";

const PersonalSettingsSpacesTableCell = ({
  children,
  className,
  ...cellProps
}: TableCellContentProps) => {
  return (
    <TableCellContent {...cellProps} className={cx(styles.cell, className)}>
      {children}
    </TableCellContent>
  );
};

export default PersonalSettingsSpacesTableCell;
